import classes from "@/Modals/BaseModal.module.css";
import { Active, Deactivated } from "@/constant/imagePath";
import { STATUS, statusLabels } from "@/constant/statusConstants";
import { mergeClass } from "@/utils/helper";

const statusLabelsMap = statusLabels();

export default function StatusInput({
  formik,
  saveError,
  label = "Status",
  statusRadioOptions = [
    {
      value: STATUS.ACTIVE,
      label: statusLabelsMap[STATUS.ACTIVE],
      imageSrc: Active,
    },
    {
      value: STATUS.INACTIVE,
      label: statusLabelsMap[STATUS.INACTIVE],
      imageSrc: Deactivated,
    },
  ],
  hint = "",
}) {
  return (
    <div className={`${mergeClass(classes.Container, classes.inputDiv)}`}>
      <div>
        {label && (
          <label htmlFor={`input${label}`} className={`${classes.labelText}`}>
            <span className="mr-1 text-red-500">*</span>
            {label}
          </label>
        )}
      </div>
      <div>
        <div className={mergeClass(classes.radioGroup, classes.input)}>
          {statusRadioOptions.map((option) => (
            <label key={option.value} className={classes.radioButton}>
              <input
                id={`status-${option.value}`}
                type="radio"
                value={option.value}
                checked={formik.values.status === option.value}
                onChange={() => formik.setFieldValue("status", option.value)}
              />
              <div
                className={`${classes.customRadio} ${
                  option.value === STATUS.ACTIVE
                    ? `${mergeClass(classes.status, "active-status")}`
                    : `${mergeClass(classes.status, "deActive-status")}`
                }`}
              >
                <img src={option.imageSrc} alt={option.label} />
                <span>{option.label}</span>
              </div>
            </label>
          ))}
        </div>
        {hint && (
          <div className="relative flex-1">
            <div></div>
            <div className="mt-2 text-info-gray w-[450px]">{hint}</div>
          </div>
        )}
        {((formik.touched.status && formik.errors.status) ||
          saveError?.status === 422) && (
          <div className={classes.error}>
            {formik?.errors?.status ??
              saveError?.response?.data?.errors?.status?.join(" ")}
          </div>
        )}
      </div>
    </div>
  );
}
